import React, { FunctionComponent, ReactElement } from "react";
import { useQuery } from "@apollo/client";
import { EditorialPageQueryInterface, PressDocumentInterface } from "../../interfaces/footer/FooterInterfaces";
import { EDITORIAL_PAGE_QUERY } from "../../constants/queries/FooterQueries";
import { handleApolloError } from "../../hooks/handleApolloError";
import ReactMarkdownWithHtml from "react-markdown/with-html";
import gfm from "remark-gfm";
import Section from "../atoms/Section";
import { FormattedMessage } from "react-intl";
import PressDocument from "../atoms/PressDocument";

const Press: FunctionComponent = (): ReactElement => {
  const {
    data: editorialData,
    error: editorialError
  } = useQuery<EditorialPageQueryInterface>(EDITORIAL_PAGE_QUERY, { variables: { urlKey: "contact-presse" } });
  handleApolloError("editorial_page_query", editorialError);

  const editorialPage = editorialData?.editorialPages[0];
  const pressDocuments: PressDocumentInterface[] = editorialPage?.pressDocuments ?? [];

  return (
    <Section>
      {editorialPage && (
        <ReactMarkdownWithHtml
          allowDangerousHtml
          plugins={[gfm]}
          className="description"
        >
          {editorialPage.content}
        </ReactMarkdownWithHtml>
      )}
      <h3>
        <FormattedMessage id="press_media" />
      </h3>
      <div className="d-inline-flex">
        {pressDocuments.map((doc) => (
          <PressDocument key={doc.id} url={doc.file.url} title={doc.title} />
        ))}
      </div>
    </Section>
  );
}

export default Press;
